import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
    className?: string; // Additional classes for customization
    size?: 'sm' | 'md' | 'lg'; // Predefined sizes
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className = '', size = 'md' }) => {
    const { t } = useTranslation();
    const sizeClasses = {
        sm: 'h-5 w-5',
        md: 'h-10 w-10',
        lg: 'h-16 w-16',
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <svg
                className={`animate-spin ${sizeClasses[size]} text-sky-500`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-label={t('common.loading')}
                role="status"
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                ></circle>
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
            </svg>
            <span className="sr-only">{t('common.loading')}</span>
        </div>
    );
};

export default LoadingSpinner;
